export default "__VITE_ASSET__C7WnoAKa__"